import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import GenericErrorRetry from "@/components/GenericErrorRetry";

export const Route = createRootRoute({
  component: () => (
    <>
      <Outlet />
      {import.meta.env.VITE_ENABLE_ROUTER_DEV_TOOLS === "1" ? <TanStackRouterDevtools /> : null}
    </>
  ),
  errorComponent: GenericErrorRetry,
});
